import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/App';
import { loadRuntimeConfig } from '@/lib/runtime-config';
import '@/index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

// Fetch /config.json before mounting React. Dev mode short-circuits
// to hardcoded defaults — no fetch — so this is a microtask in Vite
// and a real network round-trip on the deployed SPA. Either way the
// SPA only renders once Cognito + API config are usable.
await loadRuntimeConfig();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
